<template>
  <div class="password-management">
    <div class="password-form" v-scale-in>
      <h3>修改密码</h3>
      <div class="form-group">
        <label>原密码</label>
        <input v-model="form.oldPassword" type="password" placeholder="请输入原密码">
      </div>
      <div class="form-group">
        <label>新密码</label>
        <input v-model="form.newPassword" type="password" placeholder="请输入新密码">
      </div>
      <div class="form-group">
        <label>确认新密码</label>
        <input v-model="form.confirmPassword" type="password" placeholder="请再次输入新密码">
      </div>
      <button class="submit-btn" @click="handleChangePassword">确认修改</button>
    </div>
  </div>
</template>

<script>
import { apiFetch } from '@/config/api'

export default {
  name: 'PasswordManagement',
  data() {
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    }
  },
  methods: {
    async handleChangePassword() {
      if (!this.form.oldPassword || !this.form.newPassword) {
        alert('请填写完整')
        return
      }
      if (this.form.newPassword !== this.form.confirmPassword) {
        alert('两次新密码输入不一致')
        return
      }

      // 确认提示
      if (!confirm('修改密码后，所有已登录的设备将被强制退出，需要重新登录。确认继续吗？')) {
        return
      }

      try {
        const user = JSON.parse(localStorage.getItem('user'))
        const res = await apiFetch('/api/auth/change-password', {
          method: 'POST',
          body: JSON.stringify({
            account: user.account,
            oldPassword: this.form.oldPassword,
            newPassword: this.form.newPassword
          })
        })

        if (res.code === 0) {
          alert('修改成功！所有设备已退出登录，请使用新密码重新登录')
          localStorage.removeItem('token')
          localStorage.removeItem('user')
          localStorage.removeItem('username')
          window.location.href = '/#/login'
          window.location.reload()
        } else {
          alert(res.msg)
        }
      } catch (e) {
        alert('修改失败')
      }
    }
  }
}
</script>

<style scoped>
.password-management { display: flex; justify-content: center; padding-top: 40px; }
.password-form { width: 400px; background: #fff; padding: 32px; border: 1px solid #e8e8e8; }
.password-form h3 { margin: 0 0 24px; font-size: 16px; font-weight: 600; color: #111; }
.form-group { margin-bottom: 20px; }
.form-group label { display: block; margin-bottom: 6px; color: #666; font-size: 13px; }
.form-group input { width: 100%; padding: 10px 12px; border: 1px solid #ddd; border-radius: 4px; box-sizing: border-box; font-size: 14px; }
.form-group input:focus { outline: none; border-color: #111; }
.submit-btn { width: 100%; padding: 11px; background: #111; color: #fff; border: none; border-radius: 4px; cursor: pointer; font-size: 14px; font-weight: 500; }
.submit-btn:hover { background: #333; }
@media screen and (max-width: 768px) {
  .password-management { padding: 12px; }
  .password-form { width: 100%; padding: 20px; box-sizing: border-box; }
  .form-group input { padding: 12px; }
  .submit-btn { padding: 14px; }
}
</style>
